import { render, staticRenderFns } from "./Admin-Dashboard.vue?vue&type=template&id=5f6d083c&"
import script from "./Admin-Dashboard.vue?vue&type=script&lang=js&"
export * from "./Admin-Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports